var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M16 4l-2.115 2.115 8.37 8.385H4v3h18.255l-8.37 8.385L16 28l12-12z","transform":"translate(-4 -4)"}));
}

IconArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
